import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from './authentication.service';

@Injectable({ providedIn: 'root' })
export class SuperadminOnlyGuard {
  constructor(
    private authService: AuthenticationService,
    private router: Router,
  ) {}

  canActivate(): boolean {
    if (this.authService.isSuperAdmin) return true;

    this.router.navigate(['/']);
    return false;
  }
}
